import API_BASE from '../../utils/api';
import React, { useState, useEffect } from "react";
import { useAuth } from "../../context/AuthContext";
import axios from "axios";
import Sidebar from "../../components/Sidebar";
import ProfileDropdown from "../../components/ProfileDropdown";

const IconEye = () => (
  <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
  </svg>
);
const IconEdit = () => (
  <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" />
  </svg>
);
const IconTrash = () => (
  <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
  </svg>
);

const PAGE_SIZE = 10;
const TRUNCATE_LENGTH = 30;

const formatClassName = (cn) => {
  if (!cn) return '';
  return /^\d+$/.test(String(cn)) ? `Class ${cn}` : cn;
};

const Truncate = ({ text, className = "" }) => {
  if (!text) return <span className="text-gray-400">—</span>;
  const str = String(text);
  if (str.length <= TRUNCATE_LENGTH) return <span className={className}>{str}</span>;
  return <span className={className} title={str}>{str.slice(0, TRUNCATE_LENGTH)}…</span>;
};

const Teachers = () => {
  const { user } = useAuth();
  const [teachers, setTeachers] = useState([]);
  const [classes, setClasses] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [viewingTeacher, setViewingTeacher] = useState(null);
  const [editingTeacher, setEditingTeacher] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    password: "teacher123",
    employeeId: "",
    phone: "",
    address: "",
    qualification: "",
    experience: "",
    joiningDate: "",
    classId: "",
    subjects: [],
    rfidCardId: "",
  });
  const [formErrors, setFormErrors] = useState({});
  const [generatingId, setGeneratingId] = useState(false);

  const [showImportModal, setShowImportModal] = useState(false);
  const [importFile, setImportFile] = useState(null);
  const [importing, setImporting] = useState(false);
  const [importResult, setImportResult] = useState(null);
  const [importError, setImportError] = useState('');
  const [showExportMenu, setShowExportMenu] = useState(false);
  const [exporting, setExporting] = useState(false);

  useEffect(() => {
    fetchTeachers();
    fetchClasses();
  }, []);

  useEffect(() => {
    const timer = setTimeout(() => {
      setCurrentPage(1);
    }, 300);
    return () => clearTimeout(timer);
  }, [searchTerm]);

  const fetchTeachers = async () => {
    try {
      const response = await axios.get(`${API_BASE}/teachers`);
      setTeachers(response.data);
    } catch (error) {
      console.error("Error fetching teachers:", error);
    } finally {
      setLoading(false);
    }
  };

  const fetchClasses = async () => {
    try {
      const response = await axios.get(`${API_BASE}/classes`);
      setClasses(response.data);
    } catch (error) {
      console.error("Error fetching classes:", error);
    }
  };

  const fetchNextEmployeeId = async () => {
    setGeneratingId(true);
    try {
      const res = await axios.get(`${API_BASE}/teachers/next-employee-id`);
      setFormData(f => ({ ...f, employeeId: res.data.employeeId }));
    } catch (_) {
      // Leave blank; validation will block submission until it's available
    } finally {
      setGeneratingId(false);
    }
  };

  const validateForm = () => {
    const errors = {};
    if (!formData.name.trim()) errors.name = "Name is required";
    if (!formData.email.trim()) errors.email = "Email is required";
    if (!editingTeacher && !formData.employeeId.trim()) errors.employeeId = "Employee ID could not be generated — please retry";
    if (!formData.phone.trim()) errors.phone = "Phone is required";
    else if (!/^\d{10}$/.test(formData.phone)) errors.phone = "Phone number must be exactly 10 digits";
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (formData.email && !emailRegex.test(formData.email)) errors.email = "Invalid email format";
    setFormErrors(errors);
    return Object.keys(errors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validateForm()) return;
    try {
      const teacherData = {
        ...formData,
        classId: formData.classId || undefined,
        qualification: formData.qualification || undefined,
        experience: formData.experience || undefined,
        joiningDate: formData.joiningDate || undefined,
        address: formData.address || undefined,
      };
      if (editingTeacher) {
        await axios.put(`${API_BASE}/teachers/${editingTeacher._id}`, teacherData);
        alert("Teacher updated successfully!");
      } else {
        const res = await axios.post(`${API_BASE}/teachers`, teacherData);
        alert(res.data.emailSent ? "Teacher added successfully! A welcome email was sent." : "Teacher added successfully!");
      }
      setShowModal(false);
      setEditingTeacher(null);
      resetForm();
      fetchTeachers();
    } catch (error) {
      alert(error.response?.data?.error || "Error saving teacher");
    }
  };

  const handleDelete = async (id) => {
    if (window.confirm("Are you sure you want to delete this teacher?")) {
      try {
        await axios.delete(`${API_BASE}/teachers/${id}`);
        alert("Teacher deleted successfully!");
        fetchTeachers();
      } catch (error) {
        alert("Error deleting teacher");
      }
    }
  };

  const handleEdit = (teacher) => {
    setEditingTeacher(teacher);
    setFormData({
      name: teacher.name || "",
      email: teacher.email || "",
      employeeId: teacher.employeeId || "",
      phone: teacher.phone || "",
      address: teacher.address || "",
      qualification: teacher.qualification || "",
      experience: teacher.experience || "",
      joiningDate: teacher.joiningDate ? teacher.joiningDate.split("T")[0] : "",
      classId: teacher.classId?._id || "",
      subjects: teacher.subjects || [],
      rfidCardId: teacher.rfidCardId || "",
    });
    setShowModal(true);
  };

  const resetForm = () => {
    setFormData({
      name: "", email: "", password: "teacher123", employeeId: "",
      phone: "", address: "", qualification: "", experience: "",
      joiningDate: "", classId: "", subjects: [], rfidCardId: "",
    });
    setFormErrors({});
  };

  const handlePhoneChange = (value) => {
    setFormData(f => ({ ...f, phone: value.replace(/\D/g, "").slice(0, 10) }));
  };

  const downloadTemplate = () => {
    const header = "Name,Email,Phone,Qualification,Experience,JoiningDate,Address,Class";
    const sample = "Jane Doe,jane.doe@example.com,9876543210,M.Sc B.Ed,5,2024-06-01,123 Main St,Class 5 - A";
    const blob = new Blob([`${header}\n${sample}\n`], { type: "text/csv" });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = "teacher_import_template.csv";
    a.click();
    URL.revokeObjectURL(url);
  };

  const handleBulkImport = async () => {
    if (!importFile) return;
    setImporting(true);
    setImportError("");
    setImportResult(null);
    try {
      const form = new FormData();
      form.append("file", importFile);
      const res = await axios.post(`${API_BASE}/teachers/bulk-import`, form, {
        headers: { "Content-Type": "multipart/form-data" },
      });
      setImportResult(res.data);
      fetchTeachers();
    } catch (error) {
      setImportError(error.response?.data?.error || "Failed to import file");
    } finally {
      setImporting(false);
    }
  };

  const handleExport = async (format) => {
    setShowExportMenu(false);
    setExporting(true);
    try {
      const res = await axios.get(`${API_BASE}/teachers/export?format=${format}`, { responseType: "blob" });
      const ext = format === "xlsx" ? "xlsx" : format === "json" ? "json" : "csv";
      const url = URL.createObjectURL(res.data);
      const a = document.createElement("a");
      a.href = url;
      a.download = `teachers.${ext}`;
      a.click();
      URL.revokeObjectURL(url);
    } catch (_) {
      alert("Failed to export teachers");
    } finally {
      setExporting(false);
    }
  };

  // Client-side filtering and pagination
  const filtered = teachers.filter(t =>
    t.name?.toLowerCase().includes(searchTerm.toLowerCase()) ||
    t.email?.toLowerCase().includes(searchTerm.toLowerCase()) ||
    t.employeeId?.toLowerCase().includes(searchTerm.toLowerCase()) ||
    t.phone?.includes(searchTerm) ||
    t.qualification?.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const totalPages = Math.ceil(filtered.length / PAGE_SIZE);
  const paginated = filtered.slice((currentPage - 1) * PAGE_SIZE, currentPage * PAGE_SIZE);

  if (loading) {
    return (
      <div className="flex">
        <Sidebar />
        <div className="flex-1 bg-gray-100 flex items-center justify-center h-screen">
          <div className="text-xl">Loading...</div>
        </div>
      </div>
    );
  }

  return (
    <div className="flex h-screen bg-gray-100">
      <Sidebar />
      <div className="flex-1 flex flex-col overflow-hidden">
        <nav className="bg-white shadow-sm sticky top-0 z-10">
          <div className="px-6 py-4 flex justify-between items-center">
            <h1 className="text-2xl font-semibold text-gray-800">Teacher Management</h1>
            <ProfileDropdown />
          </div>
        </nav>

        <div className="flex-1 overflow-auto p-6">
          {/* Toolbar */}
          <div className="bg-white rounded-lg shadow p-4 mb-5 flex flex-col sm:flex-row gap-3 items-center justify-between">
            <input
              type="text"
              placeholder="Search by name, email, employee ID, phone, qualification..."
              value={searchTerm}
              onChange={e => setSearchTerm(e.target.value)}
              className="flex-1 border rounded-lg px-4 py-2 focus:outline-none focus:ring-2 focus:ring-indigo-500"
            />
            <div className="flex items-center gap-2 flex-wrap justify-end">
              <div className="relative">
                <button
                  onClick={() => setShowExportMenu(s => !s)}
                  disabled={exporting}
                  className="bg-white border border-gray-300 text-gray-700 px-4 py-2 rounded-lg hover:bg-gray-50 flex items-center gap-2 whitespace-nowrap disabled:opacity-50"
                >
                  {exporting ? "Exporting..." : "Export ▾"}
                </button>
                {showExportMenu && (
                  <div className="absolute right-0 mt-1 w-36 bg-white border rounded-lg shadow-lg z-20 overflow-hidden">
                    <button onClick={() => handleExport("csv")} className="w-full text-left px-4 py-2 text-sm hover:bg-gray-50">Export CSV</button>
                    <button onClick={() => handleExport("xlsx")} className="w-full text-left px-4 py-2 text-sm hover:bg-gray-50">Export XLS</button>
                    <button onClick={() => handleExport("json")} className="w-full text-left px-4 py-2 text-sm hover:bg-gray-50">Export JSON</button>
                  </div>
                )}
              </div>
              <button
                onClick={() => { setImportFile(null); setImportResult(null); setImportError(""); setShowImportModal(true); }}
                className="bg-white border border-gray-300 text-gray-700 px-4 py-2 rounded-lg hover:bg-gray-50 flex items-center gap-2 whitespace-nowrap"
              >
                Bulk Import
              </button>
              <button
                onClick={() => { resetForm(); setEditingTeacher(null); setShowModal(true); fetchNextEmployeeId(); }}
                className="bg-indigo-600 text-white px-5 py-2 rounded-lg hover:bg-indigo-700 flex items-center gap-2 whitespace-nowrap"
              >
                <span className="text-lg leading-none">+</span> Add New Teacher
              </button>
            </div>
          </div>

          {/* Table */}
          <div className="bg-white rounded-lg shadow overflow-hidden">
            <div className="overflow-x-auto">
              <table className="min-w-full divide-y divide-gray-200">
                <thead className="bg-gray-50">
                  <tr>
                    <th className="px-5 py-3 text-left text-xs font-semibold text-gray-500 uppercase tracking-wider">#</th>
                    <th className="px-5 py-3 text-left text-xs font-semibold text-gray-500 uppercase tracking-wider">Employee ID</th>
                    <th className="px-5 py-3 text-left text-xs font-semibold text-gray-500 uppercase tracking-wider">Name</th>
                    <th className="px-5 py-3 text-left text-xs font-semibold text-gray-500 uppercase tracking-wider">Email</th>
                    <th className="px-5 py-3 text-left text-xs font-semibold text-gray-500 uppercase tracking-wider">Phone</th>
                    <th className="px-5 py-3 text-left text-xs font-semibold text-gray-500 uppercase tracking-wider">Qualification</th>
                    <th className="px-5 py-3 text-left text-xs font-semibold text-gray-500 uppercase tracking-wider">Class</th>
                    <th className="px-5 py-3 text-center text-xs font-semibold text-gray-500 uppercase tracking-wider">Actions</th>
                  </tr>
                </thead>
                <tbody className="bg-white divide-y divide-gray-200">
                  {paginated.length === 0 ? (
                    <tr>
                      <td colSpan="8" className="px-6 py-12 text-center text-gray-500">
                        <div className="text-4xl mb-2">👨‍🏫</div>
                        <p>{searchTerm ? "No teachers match your search." : "No teachers found."}</p>
                      </td>
                    </tr>
                  ) : (
                    paginated.map((teacher, idx) => (
                      <tr key={teacher._id} className="hover:bg-gray-50 transition">
                        <td className="px-5 py-4 text-sm text-gray-500">
                          {(currentPage - 1) * PAGE_SIZE + idx + 1}
                        </td>
                        <td className="px-5 py-4 text-sm font-mono text-gray-700 whitespace-nowrap">
                          {teacher.employeeId || <span className="text-gray-400">—</span>}
                        </td>
                        <td className="px-5 py-4 whitespace-nowrap">
                          <div className="flex items-center gap-2">
                            <div className="w-8 h-8 rounded-full bg-indigo-100 text-indigo-700 flex items-center justify-center text-sm font-bold flex-shrink-0">
                              {teacher.name?.charAt(0).toUpperCase()}
                            </div>
                            <Truncate text={teacher.name} className="font-semibold text-gray-800" />
                          </div>
                        </td>
                        <td className="px-5 py-4 text-sm text-gray-600 whitespace-nowrap"><Truncate text={teacher.email} /></td>
                        <td className="px-5 py-4 text-sm text-gray-600 whitespace-nowrap">{teacher.phone || <span className="text-gray-400">—</span>}</td>
                        <td className="px-5 py-4 text-sm text-gray-600 whitespace-nowrap"><Truncate text={teacher.qualification} /></td>
                        <td className="px-5 py-4 whitespace-nowrap">
                          {teacher.classId ? (
                            <span className="px-2 py-1 bg-green-100 text-green-800 rounded-full text-xs font-medium">
                              {formatClassName(teacher.classId.className)} – {teacher.classId.section}
                            </span>
                          ) : (
                            <span className="text-gray-400 text-xs italic">Not Assigned</span>
                          )}
                        </td>
                        <td className="px-5 py-4">
                          <div className="flex items-center justify-center gap-1">
                            <button
                              onClick={() => setViewingTeacher(teacher)}
                              title="View"
                              className="p-1.5 text-indigo-600 hover:bg-indigo-50 rounded-lg transition"
                            >
                              <IconEye />
                            </button>
                            <button
                              onClick={() => handleEdit(teacher)}
                              title="Edit"
                              className="p-1.5 text-amber-600 hover:bg-amber-50 rounded-lg transition"
                            >
                              <IconEdit />
                            </button>
                            <button
                              onClick={() => handleDelete(teacher._id)}
                              title="Delete"
                              className="p-1.5 text-red-600 hover:bg-red-50 rounded-lg transition"
                            >
                              <IconTrash />
                            </button>
                          </div>
                        </td>
                      </tr>
                    ))
                  )}
                </tbody>
              </table>
            </div>

            {/* Pagination */}
            {totalPages > 0 && (
              <div className="px-5 py-3 border-t flex items-center justify-between text-sm text-gray-600">
                <span>
                  Showing {filtered.length === 0 ? 0 : (currentPage - 1) * PAGE_SIZE + 1}–{Math.min(currentPage * PAGE_SIZE, filtered.length)} of {filtered.length} teachers
                </span>
                <div className="flex items-center gap-1">
                  <button
                    onClick={() => setCurrentPage(p => Math.max(1, p - 1))}
                    disabled={currentPage === 1}
                    className="px-3 py-1 rounded border disabled:opacity-40 hover:bg-gray-100 transition"
                  >
                    ←
                  </button>
                  {Array.from({ length: totalPages }, (_, i) => i + 1)
                    .filter(p => p === 1 || p === totalPages || Math.abs(p - currentPage) <= 1)
                    .reduce((acc, p, i, arr) => {
                      if (i > 0 && p - arr[i - 1] > 1) acc.push('...');
                      acc.push(p);
                      return acc;
                    }, [])
                    .map((p, i) =>
                      p === '...'
                        ? <span key={`e${i}`} className="px-2">…</span>
                        : (
                          <button
                            key={p}
                            onClick={() => setCurrentPage(p)}
                            className={`px-3 py-1 rounded border transition ${currentPage === p ? 'bg-indigo-600 text-white border-indigo-600' : 'hover:bg-gray-100'}`}
                          >
                            {p}
                          </button>
                        )
                    )}
                  <button
                    onClick={() => setCurrentPage(p => Math.min(totalPages, p + 1))}
                    disabled={currentPage === totalPages}
                    className="px-3 py-1 rounded border disabled:opacity-40 hover:bg-gray-100 transition"
                  >
                    →
                  </button>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>

      {/* View Teacher Modal */}
      {viewingTeacher && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
          <div className="bg-white rounded-xl shadow-2xl w-full max-w-lg max-h-[90vh] overflow-y-auto">
            <div className="bg-indigo-600 px-6 py-4 rounded-t-xl flex items-center justify-between">
              <div className="flex items-center gap-3">
                <div className="w-10 h-10 rounded-full bg-white text-indigo-600 flex items-center justify-center text-lg font-bold">
                  {viewingTeacher.name?.charAt(0).toUpperCase()}
                </div>
                <div>
                  <h2 className="text-xl font-bold text-white">{viewingTeacher.name}</h2>
                  <p className="text-indigo-200 text-sm">{viewingTeacher.employeeId}</p>
                </div>
              </div>
              <button onClick={() => setViewingTeacher(null)} className="text-white text-2xl hover:text-indigo-200">✕</button>
            </div>
            <div className="p-6 space-y-4">
              <div className="grid grid-cols-2 gap-3">
                <div className="bg-gray-50 rounded-lg p-3">
                  <p className="text-xs text-gray-500">Email</p>
                  <p className="font-semibold text-gray-800 break-all">{viewingTeacher.email}</p>
                </div>
                <div className="bg-gray-50 rounded-lg p-3">
                  <p className="text-xs text-gray-500">Phone</p>
                  <p className="font-semibold text-gray-800">{viewingTeacher.phone || '—'}</p>
                </div>
                <div className="bg-gray-50 rounded-lg p-3">
                  <p className="text-xs text-gray-500">Qualification</p>
                  <p className="font-semibold text-gray-800">{viewingTeacher.qualification || '—'}</p>
                </div>
                <div className="bg-gray-50 rounded-lg p-3">
                  <p className="text-xs text-gray-500">Experience</p>
                  <p className="font-semibold text-gray-800">{viewingTeacher.experience != null ? `${viewingTeacher.experience} yr${viewingTeacher.experience !== 1 ? 's' : ''}` : '—'}</p>
                </div>
                <div className="bg-gray-50 rounded-lg p-3">
                  <p className="text-xs text-gray-500">Joining Date</p>
                  <p className="font-semibold text-gray-800">
                    {viewingTeacher.joiningDate ? new Date(viewingTeacher.joiningDate).toLocaleDateString('en-IN') : '—'}
                  </p>
                </div>
                <div className="bg-gray-50 rounded-lg p-3">
                  <p className="text-xs text-gray-500">Assigned Class</p>
                  <p className="font-semibold text-gray-800">
                    {viewingTeacher.classId ? `${formatClassName(viewingTeacher.classId.className)} – ${viewingTeacher.classId.section}` : '—'}
                  </p>
                </div>
              </div>
              {viewingTeacher.address && (
                <div className="bg-gray-50 rounded-lg p-3">
                  <p className="text-xs text-gray-500">Address</p>
                  <p className="font-semibold text-gray-800">{viewingTeacher.address}</p>
                </div>
              )}
            </div>
            <div className="px-6 pb-4 flex justify-end gap-2">
              <button
                onClick={() => { setViewingTeacher(null); handleEdit(viewingTeacher); }}
                className="px-4 py-2 bg-amber-500 text-white rounded-lg hover:bg-amber-600 transition text-sm"
              >
                Edit Teacher
              </button>
              <button onClick={() => setViewingTeacher(null)} className="px-4 py-2 bg-gray-200 text-gray-700 rounded-lg hover:bg-gray-300 transition text-sm">
                Close
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Add/Edit Modal */}
      {showModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
          <div className="bg-white rounded-xl shadow-2xl w-full max-w-2xl max-h-[90vh] overflow-y-auto">
            <div className="bg-indigo-600 px-6 py-4 rounded-t-xl flex items-center justify-between">
              <h3 className="text-lg font-bold text-white">
                {editingTeacher ? "Edit Teacher" : "Add New Teacher"}
              </h3>
              <button onClick={() => { setShowModal(false); setEditingTeacher(null); }} className="text-white text-2xl hover:text-indigo-200">✕</button>
            </div>

            <form onSubmit={handleSubmit} className="p-6">
              <div className="grid grid-cols-2 gap-4">
                {/* Left Column */}
                <div className="space-y-4">
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">Full Name *</label>
                    <input
                      type="text"
                      required
                      value={formData.name}
                      onChange={e => setFormData({ ...formData, name: e.target.value })}
                      className={`w-full border rounded-lg px-3 py-2 focus:outline-none focus:ring-2 focus:ring-indigo-500 ${formErrors.name ? "border-red-500" : ""}`}
                    />
                    {formErrors.name && <p className="text-xs text-red-500 mt-1">{formErrors.name}</p>}
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">Email *</label>
                    <input
                      type="email"
                      required
                      value={formData.email}
                      onChange={e => setFormData({ ...formData, email: e.target.value })}
                      className={`w-full border rounded-lg px-3 py-2 focus:outline-none focus:ring-2 focus:ring-indigo-500 ${formErrors.email ? "border-red-500" : ""}`}
                    />
                    {formErrors.email && <p className="text-xs text-red-500 mt-1">{formErrors.email}</p>}
                  </div>
                  {!editingTeacher && (
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-1">Password</label>
                      <input
                        type="password"
                        value={formData.password}
                        onChange={e => setFormData({ ...formData, password: e.target.value })}
                        className="w-full border rounded-lg px-3 py-2 focus:outline-none focus:ring-2 focus:ring-indigo-500"
                        placeholder="Default: teacher123"
                      />
                    </div>
                  )}
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">Employee ID</label>
                    <input
                      type="text"
                      readOnly
                      value={generatingId ? "Generating…" : formData.employeeId}
                      className={`w-full border rounded-lg px-3 py-2 bg-gray-100 text-gray-500 cursor-not-allowed focus:outline-none ${formErrors.employeeId ? "border-red-500" : ""}`}
                    />
                    {formErrors.employeeId && <p className="text-xs text-red-500 mt-1">{formErrors.employeeId}</p>}
                    {!editingTeacher && !formErrors.employeeId && <p className="text-xs text-gray-400 mt-1">Auto-generated, cannot be edited</p>}
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">Phone *</label>
                    <input
                      type="text"
                      required
                      inputMode="numeric"
                      maxLength={10}
                      value={formData.phone}
                      onChange={e => handlePhoneChange(e.target.value)}
                      className={`w-full border rounded-lg px-3 py-2 focus:outline-none focus:ring-2 focus:ring-indigo-500 ${formErrors.phone ? "border-red-500" : ""}`}
                      placeholder="10-digit mobile number"
                    />
                    {formErrors.phone && <p className="text-xs text-red-500 mt-1">{formErrors.phone}</p>}
                  </div>
                  {editingTeacher && (
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-1">RFID Card ID</label>
                      <input
                        type="text"
                        value={formData.rfidCardId}
                        onChange={e => setFormData({ ...formData, rfidCardId: e.target.value })}
                        className="w-full border rounded-lg px-3 py-2 focus:outline-none focus:ring-2 focus:ring-indigo-500"
                        placeholder="Scan or enter biometric/RFID card ID"
                      />
                      <p className="text-xs text-gray-400 mt-1">Only needed if biometric/RFID attendance is enabled by the super admin.</p>
                    </div>
                  )}
                </div>

                {/* Right Column */}
                <div className="space-y-4">
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">Qualification</label>
                    <input
                      type="text"
                      value={formData.qualification}
                      onChange={e => setFormData({ ...formData, qualification: e.target.value })}
                      className="w-full border rounded-lg px-3 py-2 focus:outline-none focus:ring-2 focus:ring-indigo-500"
                      placeholder="e.g., M.Sc, B.Ed"
                    />
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">Experience (years)</label>
                    <select
                      value={formData.experience}
                      onChange={e => setFormData({ ...formData, experience: e.target.value })}
                      className="w-full border rounded-lg px-3 py-2 focus:outline-none focus:ring-2 focus:ring-indigo-500"
                    >
                      <option value="">Select experience</option>
                      {Array.from({ length: 21 }, (_, i) => i).map(yr => (
                        <option key={yr} value={yr}>{yr} {yr === 1 ? "year" : "years"}</option>
                      ))}
                      <option value="20+">20+ years</option>
                    </select>
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">Joining Date</label>
                    <input
                      type="date"
                      value={formData.joiningDate}
                      onChange={e => setFormData({ ...formData, joiningDate: e.target.value })}
                      className="w-full border rounded-lg px-3 py-2 focus:outline-none focus:ring-2 focus:ring-indigo-500"
                    />
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">Assign Class</label>
                    <select
                      value={formData.classId}
                      onChange={e => setFormData({ ...formData, classId: e.target.value })}
                      className="w-full border rounded-lg px-3 py-2 focus:outline-none focus:ring-2 focus:ring-indigo-500"
                    >
                      <option value="">-- No Class Assigned --</option>
                      {classes.map(cls => (
                        <option key={cls._id} value={cls._id}>{cls.className} - {cls.section}</option>
                      ))}
                    </select>
                    <p className="text-xs text-gray-500 mt-1">Leave empty if not class teacher</p>
                  </div>
                </div>

                {/* Address - full width */}
                <div className="col-span-2">
                  <label className="block text-sm font-medium text-gray-700 mb-1">Address</label>
                  <textarea
                    value={formData.address}
                    onChange={e => setFormData({ ...formData, address: e.target.value })}
                    rows="2"
                    className="w-full border rounded-lg px-3 py-2 focus:outline-none focus:ring-2 focus:ring-indigo-500"
                  />
                </div>
              </div>

              <div className="mt-6 flex justify-end gap-3 pt-4 border-t">
                <button
                  type="button"
                  onClick={() => { setShowModal(false); setEditingTeacher(null); }}
                  className="px-4 py-2 border rounded-lg text-gray-600 hover:bg-gray-100"
                >
                  Cancel
                </button>
                <button type="submit" className="px-5 py-2 bg-indigo-600 text-white rounded-lg hover:bg-indigo-700">
                  {editingTeacher ? "Update" : "Save"} Teacher
                </button>
              </div>
            </form>
          </div>
        </div>
      )}

      {/* Bulk Import Modal */}
      {showImportModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
          <div className="bg-white rounded-xl shadow-2xl w-full max-w-lg max-h-[90vh] overflow-y-auto">
            <div className="bg-indigo-600 px-6 py-4 rounded-t-xl flex items-center justify-between">
              <h3 className="text-lg font-bold text-white">Bulk Import Teachers</h3>
              <button onClick={() => setShowImportModal(false)} className="text-white text-2xl hover:text-indigo-200">✕</button>
            </div>
            <div className="p-6 space-y-4">
              <p className="text-sm text-gray-600">
                Upload a CSV or Excel file with columns: <strong>Name, Email</strong> (required), Phone, Qualification, Experience, JoiningDate, Address, Class.
                The Class column should match an existing class, e.g. "Class 5 - A" (or use separate Class and Section columns).
                Employee IDs are generated automatically and a welcome email is sent to each new teacher.
              </p>
              <button type="button" onClick={downloadTemplate} className="text-sm text-indigo-600 hover:underline">
                Download CSV template
              </button>
              <div>
                <input
                  type="file"
                  accept=".csv,.xlsx,.xls"
                  onChange={e => { setImportFile(e.target.files[0] || null); setImportResult(null); setImportError(""); }}
                  className="w-full border rounded-lg px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-indigo-500"
                />
              </div>
              {importError && <div className="p-3 bg-red-50 border border-red-200 text-red-700 rounded-lg text-sm">{importError}</div>}
              {importResult && (
                <div className="space-y-2">
                  <div className="p-3 bg-green-50 border border-green-200 text-green-700 rounded-lg text-sm">
                    {importResult.created} of {importResult.total} teacher(s) created successfully.
                    {importResult.failed > 0 && ` ${importResult.failed} failed.`}
                  </div>
                  {importResult.failed > 0 && (
                    <div className="max-h-40 overflow-y-auto border rounded-lg divide-y text-sm">
                      {importResult.results.filter(r => r.status === 'error').map(r => (
                        <div key={r.row} className="px-3 py-2 text-red-600">
                          Row {r.row} ({r.email || r.name || 'unknown'}): {r.error}
                        </div>
                      ))}
                    </div>
                  )}
                  {importResult.results.some(r => r.warning) && (
                    <div className="max-h-40 overflow-y-auto border rounded-lg divide-y text-sm">
                      {importResult.results.filter(r => r.warning).map(r => (
                        <div key={r.row} className="px-3 py-2 text-amber-600">
                          Row {r.row} ({r.email || r.name || 'unknown'}): {r.warning} — teacher created without a class assigned.
                        </div>
                      ))}
                    </div>
                  )}
                </div>
              )}
              <div className="flex justify-end gap-3 pt-2">
                <button type="button" onClick={() => setShowImportModal(false)} className="px-4 py-2 border rounded-lg text-gray-600 hover:bg-gray-100">
                  Close
                </button>
                <button
                  type="button"
                  onClick={handleBulkImport}
                  disabled={!importFile || importing}
                  className="px-5 py-2 bg-indigo-600 text-white rounded-lg hover:bg-indigo-700 disabled:opacity-50"
                >
                  {importing ? "Importing..." : "Import"}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Teachers;
